import { InputLabel, MenuItem, Typography } from '@mui/material';
import { useFormContext } from 'react-hook-form';

import Flex from '@Components/Bases/Flex';
import FormRadio from '@Components/Form/FormRadio';
import FormSelect from '@Components/Form/FormSelect';
import { disabledFormSelectStyles } from '@Components/Form/styles';
import { useGreenhouseGoalTerm } from '../../GreenhouseGoalTermProvider/GreenhouseGoalTermProvider';
import { NetZeroLabelStyles } from './styles';
import { booleanOptions } from './utils';

type NetZeroAcceptanceProps = {
  isCompletedTh: boolean;
  isCompletedEn: boolean;
};

const NetZeroAcceptance = ({
  isCompletedTh,
  isCompletedEn,
}: NetZeroAcceptanceProps) => {
  const { certTgo, sbtiGasTarget } = useGreenhouseGoalTerm();

  const { setValue, unregister, watch } = useFormContext();
  const [isTgo, isSbti] = watch(['isTgo', 'isSbti']);

  const disabledSelectTgo = !isTgo || isTgo === 'false';
  const disabledSelectSbti = !isSbti || isSbti === 'false';

  return (
    <>
      <Typography fontWeight={800} mt={4}>
        มาตรฐานการตั้งเป้าหมายการปล่อยก๊าซเรือนกระจกสุทธิเป็นศูนย์ (Net-Zero
        Greenhouse Gas Emissions)
      </Typography>
      <Flex gap={2} mt={1}>
        <InputLabel
          required
          sx={{
            mt: 1,
            textAlign: 'end',
            minWidth: '350px',
          }}
        >
          องค์การบริหารจัดการก๊าซเรือนกระจก (อบก.)
        </InputLabel>
        <Flex flexDirection={'column'} width={'100%'}>
          <FormRadio
            disabled={isCompletedTh || isCompletedEn}
            name="isTgo"
            options={booleanOptions}
            row={true}
            onChange={(event) => {
              const value = event.target.value;

              setValue('isTgo', value);
              unregister('tgoId');
              setValue('tgoId', '');
            }}
          />
          <FormSelect
            name="tgoId"
            placeholder="โปรดเลือก"
            fullWidth
            sx={
              disabledSelectTgo || isCompletedTh || isCompletedEn
                ? disabledFormSelectStyles
                : undefined
            }
          >
            {certTgo?.map((option) => (
              <MenuItem key={option.id} value={option.id}>
                {option.nameTh}
              </MenuItem>
            ))}
          </FormSelect>
        </Flex>
      </Flex>
      <Flex gap={2} mt={1}>
        <NetZeroLabelStyles required sx={{ mt: 1, pl: 6, maxWidth: 350 }}>
          การตั้งเป้าหมายการปล่อยก๊าซเรือนกระจก สุทธิเป็นศูนย์ตาม Science-based
          Targets (SBTi)
        </NetZeroLabelStyles>
        <Flex flexDirection={'column'} width={'100%'}>
          <FormRadio
            name="isSbti"
            disabled={isCompletedTh || isCompletedEn}
            options={booleanOptions}
            row={true}
            onChange={(event) => {
              const value = event.target.value;

              setValue('isSbti', value);
              unregister('sbtiId');
              setValue('sbtiId', '');
            }}
          />
          <FormSelect
            name="sbtiId"
            placeholder="โปรดเลือก"
            fullWidth
            sx={
              disabledSelectSbti || isCompletedTh || isCompletedEn
                ? disabledFormSelectStyles
                : undefined
            }
          >
            {sbtiGasTarget?.map((option) => (
              <MenuItem key={option.id} value={option.id}>
                {option.nameTh}
              </MenuItem>
            ))}
          </FormSelect>
        </Flex>
      </Flex>
    </>
  );
};

export default NetZeroAcceptance;
